import { useSyncExternalStore } from 'react';

/**
 * Desde aquí se ve el lateral de escritorio: el `lateral` de tailwind.config.ts. Ancho y además
 * alto: un teléfono acostado (896×414) usa el menú del teléfono.
 */
export const ESCRITORIO = '(min-width: 768px) and (min-height: 520px)';

function alCambiarElAncho(avisar: () => void): () => void {
  const consulta = window.matchMedia(ESCRITORIO);
  consulta.addEventListener('change', avisar);
  return () => consulta.removeEventListener('change', avisar);
}

/** ¿Se ve el lateral de escritorio? Cambia al girar el teléfono o estirar la ventana. */
export function useEsEscritorio(): boolean {
  return useSyncExternalStore(
    alCambiarElAncho,
    () => window.matchMedia(ESCRITORIO).matches,
    () => true,
  );
}
